var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _setup.franchises.length
        ? _c("div", { ref: "container" }, [
            _c("nav", { staticClass: "navbar navbar-default" }, [
              _c("div", { staticClass: "container-fluid" }, [
                _c(
                  "form",
                  {
                    ref: "form",
                    staticClass: "float-start d-flex align-items-center gap-1",
                  },
                  [
                    _c(_setup.ReportMenu, {
                      attrs: { "reports-module": _setup.reportsModule },
                    }),
                    _vm._v(" "),
                    _setup.formData.reportName === "birthdayDates"
                      ? [
                          _c(_setup.MonthsFilter),
                          _vm._v(" "),
                          _c(_setup.FranchisesFilter, {
                            attrs: { "allow-all": true },
                          }),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _setup.formData.reportName === "birthdayPartyEnquiries"
                      ? [
                          _c(_setup.FranchisesFilter, {
                            attrs: { "allow-all": true },
                          }),
                          _vm._v(" "),
                          _c(_setup.DateRangeFilter, {
                            attrs: { "reports-module": _setup.reportsModule },
                          }),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _setup.formData.reportName === "bookingsReport"
                      ? [
                          _c(_setup.DateRangeFilter, {
                            attrs: { "reports-module": _setup.reportsModule },
                          }),
                          _vm._v(" "),
                          _c(_setup.FranchisesFilter, {
                            attrs: { "allow-all": true },
                          }),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _setup.formData.reportName === "courseDatesData"
                      ? [
                          _c(_setup.DateRangeFilter, {
                            attrs: { "reports-module": _setup.reportsModule },
                          }),
                          _vm._v(" "),
                          _c(_setup.FranchisesFilter, {
                            attrs: { "allow-all": true },
                          }),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _setup.formData.reportName === "customerBookingData"
                      ? [
                          _c(_setup.DateRangeFilter, {
                            attrs: { "reports-module": _setup.reportsModule },
                          }),
                          _vm._v(" "),
                          _c(_setup.FranchisesFilter, {
                            attrs: { "allow-all": true },
                          }),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _setup.formData.reportName === "customerCredit"
                      ? [
                          _c(_setup.FranchisesFilter, {
                            attrs: { "allow-all": true },
                          }),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _setup.formData.reportName === "customerPostcodes"
                      ? [
                          _c(_setup.DateRangeFilter, {
                            attrs: { "reports-module": _setup.reportsModule },
                          }),
                          _vm._v(" "),
                          _c(_setup.FranchisesFilter, {
                            attrs: { "allow-all": true },
                          }),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _setup.formData.reportName === "marketingReport"
                      ? [
                          _c(_setup.DateRangeFilter, {
                            attrs: { "reports-module": _setup.reportsModule },
                          }),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _setup.formData.reportName === "postcodes"
                      ? [
                          _c(_setup.FranchisesFilter, {
                            attrs: { "allow-all": true },
                          }),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _setup.formData.reportName === "partyBookings"
                      ? [
                          _c(_setup.DateRangeFilter, {
                            attrs: { "reports-module": _setup.reportsModule },
                          }),
                          _vm._v(" "),
                          _c(_setup.FranchisesFilter, {
                            attrs: { "allow-all": true },
                          }),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _setup.formData.reportName === "referAFriendLTV"
                      ? [
                          _c(_setup.FranchisesFilter, {
                            attrs: { "allow-all": true },
                          }),
                          _vm._v(" "),
                          _c(_setup.DateRangeFilter, {
                            attrs: { "reports-module": _setup.reportsModule },
                          }),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _setup.formData.reportName === "schoolParents"
                      ? [
                          _c(_setup.SchoolsFilter),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "text-nowrap text-muted" },
                            [_vm._v("in the last")]
                          ),
                          _vm._v(" "),
                          _c(_setup.MonthInTheLastFilter),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _setup.formData.reportName !== ""
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary btn-sm",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _setup.submitForm()
                              },
                            },
                          },
                          [_vm._v("Go\n                    ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _setup.rows && _setup.rows.length
                      ? _c("span", { staticClass: "text-nowrap" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_setup.formatNumber(_setup.rows.length)) +
                              " records found\n                    "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _setup.isLoading
                      ? _c("span", { staticClass: "ajax-spinner" }, [
                          _c("span", {
                            staticClass:
                              "ajax-spinner-icon ajax-spinner-icon-sm",
                          }),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _setup.rows && _setup.rows.length
                  ? _c(
                      "div",
                      { staticClass: "float-end" },
                      [
                        _c(
                          _setup.Button,
                          {
                            nativeOn: {
                              click: function ($event) {
                                return _setup.openPrintModal.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "bi bi-printer" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "visually-hidden" }, [
                              _vm._v("Print report"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          _setup.Button,
                          {
                            nativeOn: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _setup.downloadCSVData.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "bi bi-download" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "visually-hidden" }, [
                              _vm._v("Download CSV"),
                            ]),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _setup.rows && _setup.rows.length === 0
              ? _c("p", { staticClass: "mx-2 alert alert-warning" }, [
                  _vm._v(
                    "\n            No records match your search.\n        "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _setup.error
              ? _c("p", {
                  staticClass: "mx-2 alert alert-warning",
                  domProps: { innerHTML: _vm._s(_setup.error) },
                })
              : _vm._e(),
            _vm._v(" "),
            _setup.rows && _setup.rows.length
              ? _c("div", { staticClass: "padding-sm table-wrapper" }, [
                  _c(
                    "table",
                    { staticClass: "table table-condensed table-striped" },
                    [
                      _c("thead", [
                        _c(
                          "tr",
                          _vm._l(_setup.rows[0], function (value, heading) {
                            return _c(
                              "td",
                              {
                                key: "heading-" + heading,
                                on: {
                                  click: function ($event) {
                                    return _setup.setSortBy(heading)
                                  },
                                },
                              },
                              [
                                heading === _setup.sortBy
                                  ? _c("span", {
                                      class: {
                                        "bi-chevron-up":
                                          _setup.sortDir === "asc",
                                        "bi-chevron-down":
                                          _setup.sortDir === "desc",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(heading) +
                                    "\n                    "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_setup.sortedRows, function (row, index) {
                          return _c(
                            "tr",
                            { key: "row-" + index },
                            _vm._l(row, function (value, heading) {
                              return _c("td", {
                                key: "cell-" + heading,
                                domProps: { innerHTML: _vm._s(value) },
                              })
                            }),
                            0
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _setup.rows
        ? _c(_setup.PrintReport, {
            ref: "toPrint",
            staticStyle: { display: "none" },
            attrs: {
              "end-date": _setup.endDate,
              heading: _setup.reportLabel,
              rows: _setup.sortedRows,
              "start-date": _setup.startDate,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }